"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const events_1 = require("../../../../../constants/events");
const strings_1 = require("../../../../../constants/strings");
const approvalQuery_1 = require("../../../../../queries/approvals/approvalQuery");
const Root_1 = require("../../../../../router/Root");
const zustandStore_1 = require("../../../../../zustandStore");
const lexico = new lexico_1.default();
const CancelCardButton = ({ approvalItem }) => {
    const params = (0, react_router_1.useParams)();
    const { outcome } = approvalItem || {};
    const { setDialog, approvals, request } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const { allEvents } = request;
    const { isCreateCardSuccessful } = approvals;
    const cancelApprovalQuery = (0, approvalQuery_1.useCancelApprovalMutationQuery)();
    const activeHeaderTab = (0, zustandStore_1.useZustand)(state => state.header.activeHeaderTab);
    const [isButtonVisible, setIsButtonVisible] = (0, react_1.useState)(true);
    const isApprovedCardEvent = allEvents.some(event => event.type === events_1.events.types.purchases.requestApproved);
    const isCancelledCardEvent = allEvents.some(event => event.type === events_1.events.types.messageAdded && String(event.data?.body)?.includes('virtual card has been cancelled'));
    const handleCancelRequest = () => {
        cancelApprovalQuery.mutate({
            subjectId: approvalItem?.subjectId,
            taskId: approvalItem?.id,
            virtualCardId: approvalItem?.request?.virtualCardId,
        }, {
            onSuccess: () => {
                setIsButtonVisible(false);
            },
            onError: () => {
                setIsButtonVisible(true);
            },
            onSettled: () => {
                if (params?.['approvalId']) {
                    void Root_1.queryClient.invalidateQueries({
                        queryKey: ['approval', params?.['approvalId']],
                    });
                }
            },
        });
    };
    const openConfirmCancelCardAside = () => {
        if (!approvalItem?.subjectId || !approvalItem?.id) {
            return;
        }
        setDialog({
            message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                ? strings_1.walletStrings.HSBC_CANCEL_CARD_MESSAGE_TEXT
                : lexico.trc('Confirmation message', 'Cancelling this card will not reverse any pending charges. Please look for the settlement records for those charges in the credit card statement sent by your card provider.'),
            type: strings_1.notificationStrings.WARNING,
            open: true,
            actionText: 'YES',
            showCancel: true,
            onAccept: handleCancelRequest,
        });
    };
    const showBtnCondition = outcome === 'APPROVED' && !isCancelledCardEvent
        ? true
        : activeHeaderTab === 'approved' || (!isCancelledCardEvent && (isCreateCardSuccessful || isApprovedCardEvent));
    const isOnActivityPage = location.pathname.startsWith('/approvals') || (location.pathname.startsWith('/activity') && !params['approvalId']);
    const showBtn = isOnActivityPage
        ? showBtnCondition && isButtonVisible && activeHeaderTab === 'approved'
        : showBtnCondition && activeHeaderTab
            ? activeHeaderTab === 'approved' ||
                (activeHeaderTab === 'pending' && (isCreateCardSuccessful || isApprovedCardEvent))
            : showBtnCondition;
    return (showBtn && ((0, jsx_runtime_1.jsx)(material_1.Button, { variant: "contained", style: {
            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? { textTransform: 'uppercase' } : {}),
        }, onClick: openConfirmCancelCardAside, children: lexico.trc('Button', 'Cancel card') })));
};
exports.default = CancelCardButton;
